import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateRows: 'max-content max-content',
	background: theme.palette.neutral[40],
	padding: 16,
	boxSizing: 'border-box',
	borderRadius: 8,
}));
